import {Application} from './Application/Application'
import {BodyWidget} from './CanvasWidgets/BodyWidget'

export const Canvas = ({app}: {app: Application}) => {
  return <BodyWidget app={app} />
}
